import { styled, Grid, gridClasses } from "@mui/material";
const Container = styled(Grid, {
  shouldForwardProp: (prop) => !["spacingX", "spacingY"].includes(prop)
})(({ theme, spacingX = 3, spacingY = 3 }) => {
  return {
    margin: 0,
    width: "100%",
    marginTop: 12 - spacingY * 8 / 2,
    [`& > .${gridClasses.item}`]: {
      paddingTop: theme.spacing(spacingY / 2),
      paddingBottom: theme.spacing(spacingY / 2),
      paddingRight: theme.spacing(spacingX / 2),
      paddingLeft: theme.spacing(spacingX / 2)
    }
  };
});
Container.defaultProps = {
  container: true
};
export {
  Container
};
